import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import GoAutoWarrantyWrapper from "@components/layouts/goAutoWarrantyWrapper";

export default function Home(): ReactElement {
    return (
        <GoAutoWarrantyWrapper>
            <TermsAndConditions
                category="GoAutoWarranty"
                domain="GoAutoWarranty.com"
            />
        </GoAutoWarrantyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
